import { isRecord } from "@atlassiansox/bxp-shared-utils";

import { EnterprisePricingTier, FlatRatePricing } from "./typings";

export function isEnterprisePricingTier(
    tier: unknown
): tier is EnterprisePricingTier {
    if (!isRecord(tier)) {
        return false;
    }

    return (
        typeof (tier as EnterprisePricingTier).at === "number" &&
        typeof (tier as EnterprisePricingTier).above === "number"
    );
}

export function isEnterprisePricingTiers(
    tiers: unknown
): tiers is EnterprisePricingTier[] {
    if (!Array.isArray(tiers)) {
        return false;
    }

    return tiers.every(isEnterprisePricingTier);
}

export function isFlatRatePricing(
    pricing: unknown
): pricing is FlatRatePricing {
    return (
        !!pricing &&
        !Array.isArray(pricing) &&
        typeof (pricing as FlatRatePricing).monthly === "number" &&
        typeof (pricing as FlatRatePricing).annually === "number"
    );
}
